import ApiService from "@/core/services/api.service";
// action types
export const GET_CUSTOM_COLOR_BY_COMPANY = "getCustomColorByCompany";
export const UPDATE_CUSTOM_COLOR_BY_COMPANY = "updateCustomColorByCompany";

export default {
  state: {
    path: "custom_color"
  },
  getters: {},
  actions: {
    [GET_CUSTOM_COLOR_BY_COMPANY](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}_by_company/${payload.company_id}`
      );
    },
    [UPDATE_CUSTOM_COLOR_BY_COMPANY](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}_by_company/${payload.company_id}`,
        payload.data
      );
    }
  },
  mutations: {}
};
